<template>
	<el-drawer class="drawer_uploadImg" title="上传图片" :visible.sync="visible" @close='addShopStateClose' size="520px" :modal-append-to-body="false" :close-on-click-modal="false">
		<div style="padding-top:30px;">
			<div class="selectList" v-if="$public.isNull(fatherId)">
				<div class="label">评论数：</div>
				<el-input v-model="commentCount1" @input="inputCommentCount" style="width:368px;"></el-input>
			</div>
			<div class="selectList">
				<div class="label">点赞数：</div>
				<el-input v-model="likeCount1" @input="inputLikeCount" style="width:368px;"></el-input>
			</div>
			<div class="submit" @click="submit">确定</div>
		</div>
	</el-drawer>
</template>
<script>
	export default {
		data() {
			return {
				
				visible: true,
				
				//
				commentCount1:0,
				likeCount1:0,

			};
		},
		props:{
			fatherId:{
				default:''
			},
			commentCount:{
				default:0,
			},
			likeCount:{
				default:0,
			}
		},
		mounted() {
			this.commentCount1 = this.commentCount;
			this.likeCount1 = this.likeCount;
		},
		methods: {
			addShopStateClose(){
				this.$emit("submit",{type:'close',data:{}})
			},
			submit(){
				if(this.$public.isNull(this.commentCount1)){
					this.$message({
						message: '评论数不能为空',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.likeCount1)){
					this.$message({
						message: '点赞数不能为空',
						type: 'error'
					});
					return ;
				}
				let obj = {
					commentCount:this.commentCount1,
					likeCount:this.likeCount1,
				}
				this.$emit("submit",{type:'success',data:obj})
			},
			inputCommentCount(){
				this.commentCount1 = this.$public.FInt(this.commentCount1)
			},
			inputLikeCount(){
				this.likeCount1 = this.$public.FInt(this.likeCount1)
			},
		}
	};
</script>

<style scoped lang="scss">
	.drawer_uploadImg {
		::v-deep .el-drawer__header {
			margin-bottom: 10px;
		}
		
		::v-deep .el-drawer__body {
			height: calc(100% - 55px);
			overflow-y: auto;
		}
		.selectList{
			padding:16px 32px;
			.label{
				display: inline-block;font-size: 14px;color:$color333;margin-right: 10px;line-height: 40px;vertical-align: top;
			}
		}
		.submit{
			background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);border-radius: 8px;line-height: 44px;margin:50px 32px 30px;text-align: center;color:#fff;font-size: 14px;cursor: pointer;
		}
	}
</style>
